/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from 'react-i18next';
import { PaymentPlusIcon } from 'assets/img/icons/icons';
import { useQuery } from 'react-query';
import { useState } from 'react';

import './payment.scss';
import paymentMethodService from 'service/paymentMethod';

interface PaymentMethod {
  id: string;
  name: { [key: string]: string }; // Language-keyed name object
  photo: string;
  pid: number; // Added to check cash vs other methods
  payment_type_pid: number;
}

interface LegalEntityPaymentMethod {
  id: string;
  paymentMethod: PaymentMethod;
}

interface PaymentFormItem {
  img: string;
  totalPrice: number;
  payment_method_pid: number;
  payment_type_pid: number;
}

interface PaymentMethodsProps {
  setPaymentFormsData?: (data: PaymentFormItem[]) => void;
  paymentFormsData?: PaymentFormItem[];
}

const PaymentMetohds = ({
  setPaymentFormsData,
  paymentFormsData
}: PaymentMethodsProps) => {
  const { t, i18n } = useTranslation();
  const [showAll, setShowAll] = useState(false);

  const { data } = useQuery(['GET_PAYMENT_METHOD'], () => {
    const res = paymentMethodService
      .getList({ offset: 0, limit: 100, status: true })
      .then((res: any) => res?.legal_entity_payment_methods);
    return res;
  });

  const displayedMethods = showAll ? data : data?.slice(0, 3);

  const handleToggleShow = () => {
    setShowAll(prev => !prev);
  };

  const handlePaymentClick = (item: LegalEntityPaymentMethod) => {
    if (!setPaymentFormsData || !paymentFormsData) return;

    const pid = item.paymentMethod.pid;
    const payment_type_pid = item?.paymentMethod?.payment_type_pid || 1;
    // Count existing forms for this payment_method_pid
    const pidCount = paymentFormsData.filter(
      form => form.payment_method_pid === pid
    ).length;

    // Check limits: 2 for pid 5, 3 for all others
    if (pid === 5 && pidCount >= 2) return; // Don't add if limit reached
    if (pid !== 5 && pidCount >= 3) return; // Don't add if limit reached

    const photoUrl = `${process.env.REACT_APP_CDN_URL}${item.paymentMethod.photo}`;
    const updatedData = [
      ...paymentFormsData,
      {
        img: photoUrl,
        totalPrice: 0,
        payment_method_pid: pid,
        payment_type_pid: payment_type_pid
      }
    ];
    setPaymentFormsData(updatedData);
  };

  return (
    <div className="payment-metohds">
      <h4 className="payment-metohds-title">{t('payment_type')}</h4>

      <div className="payment-metohds-types">
        {displayedMethods?.map((items: LegalEntityPaymentMethod) => (
          <div
            key={items.id}
            className="payment-metohds-type"
            onClick={() => handlePaymentClick(items)}
          >
            <img
              src={`${process.env.REACT_APP_CDN_URL}${items?.paymentMethod?.photo}`}
              alt="card"
            />
            <p className="payment-metohds-type-title">
              {items?.paymentMethod?.name?.[i18n?.language]}
            </p>
            <div onClick={() => handlePaymentClick(items)}>
              <PaymentPlusIcon />
            </div>
          </div>
        ))}
      </div>
      {!showAll && data && data.length > 3 && (
        <button className="show-other-btn" onClick={handleToggleShow}>
          {t('show_others')}
        </button>
      )}
    </div>
  );
};

export default PaymentMetohds;
